/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxfrag */

import React, { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type BeforeTabProps = {
	elementBefore?: ReactNode | undefined;
};

const BeforeTab = ({ elementBefore }: BeforeTabProps) =>
	elementBefore ? (
		<>
			<Box
				xcss={
					fg('blu-6305_tab_item_styling_in_horizontal_navigation')
						? elementBeforeStyles
						: elementBeforeStylesOld
				}
				style={{
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					display: 'var(--display-icon-before, flex)',
				}}
			>
				{elementBefore}
			</Box>
		</>
	) : null;

const elementBeforeStylesOld = xcss({
	inlineSize: token('space.250', '20px'),
	blockSize: token('space.250', '20px'),
	alignItems: 'center',
	justifyContent: 'center',
});

const elementBeforeStyles = xcss({
	inlineSize: token('space.300', '24px'),
	blockSize: token('space.300', '24px'),
	alignItems: 'center',
	justifyContent: 'center',
});

export default BeforeTab;
